import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import { MonthView , TransitionView } from 'react-date-picker';
import * as Actions from 'actions';

const MapStormDatePickerModal = (props) => {

  let date_timer = null;

  const handleRangeChange = (date) => {
    if(date_timer) {
      clearTimeout(date_timer);
    }

    date_timer = setTimeout(() => {
      props.addClientsFilter({
        value : date,
        type : 'storm_date',
        label : `storm date: ${moment(date[0]).format('MM/DD/YY')} - ${moment(date[1]).format('MM/DD/YY')}`
      });
      props.handleOnHide()
      props.fetchClients();
    }, 100);
  }

  return (
    <Modal
      show={props.show}
      onHide={props.handleOnHide}
      >
      <Modal.Header>
        <h3 className='text-center'>Filter Clients By Maps</h3>
        <p>Select a date range below to filter your clients by.</p>
        <p>The system will return all the clients impacted in that date range.</p>
      </Modal.Header>
      <Modal.Body>
        <div className='alert alert-info'>
          <p>This feature is in Beta, so it may take longer to load.
          If things take too long, try a smaller date range.</p>
        </div>
        <TransitionView
          footer={false}
          navigation={true}
          >
          <MonthView
            highlightWeekends={true}
            highlightToday={true}
            weekNumbers={true}
            locale='en'
            highlightRangeOnMouseMove={true}
            weekStartDay={0}
            footer={false}
            onRangeChange={handleRangeChange}
            defaultRange={[]}
          />
        </TransitionView>
      </Modal.Body>
      <Modal.Footer>
        <div className='row'>
          <div className='col-xs-12 col-md-4 col-md-offset-8'>
            <div
              onClick={props.handleOnHide}
              className='btn btn-block btn-default'
              >
              Close
            </div>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default connect(null, Actions)(MapStormDatePickerModal)



// WEBPACK FOOTER //
// ./src/browser/components/clients/map/map-storm-date-picker-modal.js